import { createClient } from "@supabase/supabase-js";
import getAPIKeys from "./getAPIKeysFromServer";

export async function createChatBot(
  name,
  companyName,
  allowedUrls,

  data,

  firstMessage,
  header,
  subHeader,
  whatsapplink,
  telegramlink,
  telegramGrouplink,
  mainColor,
  humanSpeech,
  aiSpeech,
  supportSpeech,
  backgroundColor,
  userInputColor,
  messageText,
  closeButton,
  messagePopupDelay,
  telegramBotToken,

  enterEmailText,
  emailSubmitText,
  initiallyAskForEmail,
  toAskForEmail,
  turnonai,
  languageChatBot
) {
  console.log(telegramBotToken);
  const apiKeys = await getAPIKeys();
  const supabase = createClient(apiKeys.sbUrl, apiKeys.sbApiKey);

  // get lang
  const queryParameters = new URLSearchParams(window.location.search);
  const language = queryParameters.get("la") ?? "ru";

  const answerTemplate =
    language === "en"
      ? `You are a helpful and enthusiastic support bot who can answer a given question about ${companyName} based on the context provided and the conversation history. Try to find the answer in the context. If the answer is not given in the context, find the answer in the conversation history if possible. If you really don't know the answer, say "I'm sorry, I don't know the answer to that question. An operator will assist you right here.". Don't try to make up an answer. Always speak as if you were chatting to a friend.`
      : `Ты — полезный и дружелюбный бот поддержки, который может ответить на заданный вопрос о компании ${companyName} на основе предоставленного контекста. Ищи ответ в контексте. Если ответ не содержится в контексте, скажи: "Извините, я не знаю ответа на этот вопрос. Сейчас прямо здесь вам ответит оператор". Не пытайся выдумывать ответ. Будь вежлив, ты общаешься с клиентами. Не упоминай контекст в ответах.`;

  try {
    const userSession = await supabase.auth.getSession();
    const { error } = await supabase.from("clients").insert({
      name,

      answerTemplate: answerTemplate,
      allowed_urls: allowedUrls,
      data_array: data,
      companyName,
      firstMessage,
      header,
      subHeader,
      whatsapplink,
      telegramlink,
      telegram_chat: telegramGrouplink,
      mainColor,
      humanSpeech,
      aiSpeech,
      supportSpeech,
      backgroundColor,
      userInputColor,
      messageText,
      closeButton,
      user_email: userSession.data.session.user.email,
      messagePopupDelay,
      telegramBotKey: telegramBotToken,
      language: languageChatBot,
      updated: true,

      enterEmailText,
      emailSubmitText,
      initiallyAskForEmail,
      toAskForEmail,
      turnonai,
    });
    console.log(error);

    addChatbotToUser(name);
    console.log("TELEGRAM BOT STATESDSD");
    fetch("https://ai-chat-bot-docker.onrender.com/parsedataformessegerbots", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name,
      }),
    });
  } catch (error) {
    console.log(error);
  }
}

export async function updateChatBotWithEmail(
  name,
  companyName,
  allowedUrls,
  data,

  firstMessage,
  header,
  subHeader,
  whatsapplink,
  telegramlink,
  telegramGrouplink,
  mainColor,
  humanSpeech,
  aiSpeech,
  supportSpeech,
  backgroundColor,
  userInputColor,
  messageText,
  closeButton,
  messagePopupDelay,
  telegramBotToken,
  lang,

  enterEmailText,
  emailSubmitText,
  initiallyAskForEmail,
  toAskForEmail,
  turnonai,
  languageChatBot
) {
  try {
    const apiKeys = await getAPIKeys();
    const supabase = createClient(apiKeys.sbUrl, apiKeys.sbApiKey);

    // get lang
    const queryParameters = new URLSearchParams(window.location.search);
    const language = queryParameters.get("la") ?? "ru";

    const answerTemplate =
      language === "en"
        ? `You are a helpful and enthusiastic support bot who can answer a given question about ${companyName} based on the context provided and the conversation history. Try to find the answer in the context. If the answer is not given in the context, find the answer in the conversation history if possible. If you really don't know the answer, say "I'm sorry, I don't know the answer to that question. An operator will assist you right here.". Don't try to make up an answer. Always speak as if you were chatting to a friend.`
        : `Ты — полезный и дружелюбный бот поддержки, который может ответить на заданный вопрос о компании ${companyName} на основе предоставленного контекста. Ищи ответ в контексте. Если ответ не содержится в контексте, скажи: "Извините, я не знаю ответа на этот вопрос. Сейчас прямо здесь вам ответит оператор". Не пытайся выдумывать ответ. Будь вежлив, ты общаешься с клиентами. Не упоминай контекст в ответах.`;

    const { error } = await supabase
      .from("clients")
      .update({
        answerTemplate,
        allowed_urls: allowedUrls,
        data_array: data,
        companyName,
        firstMessage,
        header,
        subHeader,
        whatsapplink,
        telegramlink,
        telegram_chat: telegramGrouplink,
        mainColor,
        humanSpeech,
        aiSpeech,
        supportSpeech,
        backgroundColor,
        userInputColor,
        messageText,
        closeButton,

        messagePopupDelay,
        telegramBotKey: telegramBotToken,
        language: languageChatBot,

        enterEmailText,
        emailSubmitText,
        initiallyAskForEmail,
        toAskForEmail,
        turnonai,
      })
      .eq("name", name);
    console.log(error);

    addChatbotToUser(name);
    console.log("TELEGRAM BOT STATESDSD");
    fetch("https://ai-chat-bot-docker.onrender.com/parsedataformessegerbots", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name,
      }),
    });
  } catch (error) {
    console.log(error);
  }
}

export async function updateAppearence(
  name,
  companyName,

  firstMessage,
  header,
  subHeader,
  whatsapplink,
  telegramlink,
  mainColor,
  humanSpeech,
  aiSpeech,
  supportSpeech,
  backgroundColor,
  userInputColor,
  messageText,
  closeButton
) {
  try {
    const apiKeys = await getAPIKeys();
    const supabase = createClient(apiKeys.sbUrl, apiKeys.sbApiKey);

    // get lang
    const queryParameters = new URLSearchParams(window.location.search);
    const language = queryParameters.get("la") ?? "ru";

    const answerTemplate =
      language === "en"
        ? `You are a helpful and enthusiastic support bot who can answer a given question about ${companyName} based on the context provided and the conversation history. Try to find the answer in the context. If the answer is not given in the context, find the answer in the conversation history if possible. If you really don't know the answer, say "I'm sorry, I don't know the answer to that question. An operator will assist you right here.". Don't try to make up an answer. Always speak as if you were chatting to a friend.`
        : `Ты — полезный и дружелюбный бот поддержки, который может ответить на заданный вопрос о компании ${companyName} на основе предоставленного контекста. Ищи ответ в контексте. Если ответ не содержится в контексте, скажи: "Извините, я не знаю ответа на этот вопрос. Сейчас прямо здесь вам ответит оператор". Не пытайся выдумывать ответ. Будь вежлив, ты общаешься с клиентами. Не упоминай контекст в ответах.`;

    const { error } = await supabase
      .from("clients")
      .update({
        answerTemplate,
        companyName,
        firstMessage,
        header,
        subHeader,
        whatsapplink,
        telegramlink,
        mainColor,
        humanSpeech,
        aiSpeech,
        supportSpeech,
        backgroundColor,
        userInputColor,
        messageText,
        closeButton,
      })
      .eq("name", name);
    console.log(error);
  } catch (error) {
    console.log(error);
  }
}

export async function updateSettings(
  name,
  allowedUrls,

  telegramGrouplink,
  messagePopupDelay,
  telegramBotToken,

  enterEmailText,
  emailSubmitText,
  initiallyAskForEmail,
  toAskForEmail,
  turnonai,
  languageChatBot
) {
  try {
    const apiKeys = await getAPIKeys();
    const supabase = createClient(apiKeys.sbUrl, apiKeys.sbApiKey);

    console.log("allowedUrls", allowedUrls, telegramBotToken);

    const { error } = await supabase
      .from("clients")
      .update({
        allowed_urls: allowedUrls,

        telegram_chat: telegramGrouplink,

        messagePopupDelay: Number(messagePopupDelay),
        telegramBotKey: telegramBotToken,

        enterEmailText,
        emailSubmitText,
        initiallyAskForEmail,
        toAskForEmail,
        turnonai,
        language: languageChatBot,
      })
      .eq("name", name);
    console.log(error);

    addChatbotToUser(name);

    console.log("TELEGRAM BOT STATESDSD");
    fetch("https://ai-chat-bot-docker.onrender.com/parsedataformessegerbots", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name,
      }),
    });
  } catch (error) {
    console.log(error);
  }
}

export async function updateData(name, data) {
  try {
    const apiKeys = await getAPIKeys();
    const supabase = createClient(apiKeys.sbUrl, apiKeys.sbApiKey);

    const { error } = await supabase
      .from("clients")
      .update({
        data_array: data,
      })
      .eq("name", name);
    console.log(error);
  } catch (error) {
    console.log(error);
  }
}

export async function updateUpdated(name) {
  try {
    const apiKeys = await getAPIKeys();
    const supabase = createClient(apiKeys.sbUrl, apiKeys.sbApiKey);

    const { error } = await supabase
      .from("clients")
      .update({
        updated: true,
      })
      .eq("name", name);
    console.log(error);
  } catch (error) {
    console.log(error);
  }
}

export async function addChatbotToUser(chatbotID) {
  const apiKeys = await getAPIKeys();
  const supabase = createClient(apiKeys.sbUrl, apiKeys.sbApiKey);

  let supabaseObject = undefined;
  const userSession = await supabase.auth.getSession();
  try {
    const { data, e } = await supabase.from("users").select();
    supabaseObject = data.find(
      (e) => e.user_email === userSession.data.session.user.email
    );
  } catch (error) {
    console.log(error);
  }
  try {
    let tempChatbots = [...supabaseObject.chat_bots];
    tempChatbots.push(chatbotID);

    await supabase
      .from("users")
      .update({ chat_bots: tempChatbots })
      .eq("user_email", userSession.data.session.user.email);
  } catch (error) {
    console.log(error);
  }
}
